import React, { useContext, useEffect, useState } from "react";
import { EducationGoalTemplate } from "../classes/goal_template_education_class";
import { FormNavigationController } from "../common/components/FormNavigationController";
import { FormTitle } from "../common/components/generalUtilities";
import { EducationForm } from "./EducationForm";
import { EducationPreview } from "./EducationPreview";
import { EducationFormContext } from "../hooks/EducationFormContext";
import { EducationGoalShape } from "../interfaces/classTypes";
import { TMDataContext } from "../../utils/custom_hooks/TMDataContext";

export const EducationContainer: React.FunctionComponent = () => {
  const { DBObject, t, navPage } = useContext(TMDataContext);
  let educationDefaults = navPage["formDefaults"]
    ? navPage["formDefaults"]
    : { user: DBObject.User };

  const educationGoalObject = new EducationGoalTemplate(educationDefaults);
  const [CRUDtype] = useState(navPage.formDefaults ? "edit" : "new");

  const [goalState, setGoalState] = useState<EducationGoalShape>(
    educationGoalObject
  );

  const [formComplete, setFormComplete] = useState(false);

  const showStep = () => {
    switch (navPage.name) {
      case "educationForm":
        return <EducationForm setStepComplete={setFormComplete} />;
        break;
      case "educationPreview":
        return <EducationPreview />;
        break;
    }
  };

  return (
    <EducationFormContext.Provider value={{ goalState, setGoalState }}>
      <div className="goal-wizard-container">
        <FormTitle
          title={t(
            `views.goals.form_titles.education_goal_${CRUDtype}${
              navPage.name.includes("Preview") && CRUDtype ? "_preview" : ""
            }`
          )}
        />
        <div className="goal-form-dashboard">{showStep()}</div>
        <FormNavigationController
          stepComplete={formComplete}
          goalState={goalState}
        />
      </div>
    </EducationFormContext.Provider>
  );
};
